import initHalfGateHero from "../initHalfGateHero.js";

document.addEventListener("DOMContentLoaded", () => {
  initHalfGateHero();
});
